export default {
  'name': { rules: [{ required: true }, { max: 80 }] },
  'description': { rules: [{ max: 80 }] },
  'street': { rules: [{ max: 250 }] },
  'zip': { rules: [{ max: 12 }] },
  'city': { rules: [{ max: 80 }] },
  'contact_name': { rules: [{ max: 80 }] },
  'contact_phone': { rules: [{ max: 16 }] },
  'contact_email': { rules: [{ type: 'email' }, { max: 254 }] }
}



// WEBPACK FOOTER //
// ./src/components/location/locationFields.js